import { AwardJudge, AwardJudgeRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const assignCountryAwardJudge: (
  fetchContext: FetchContext,
  awardId: number,
  countryId: number,
  judge: AwardJudge,
  accessToken?: string,
) => Promise<AwardJudgeRef> = (fetchContext, awardId, countryId, judge, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/awards/${awardId}/country/${countryId}/judges`,
  {
    method: 'POST',
    body: JSON.stringify(judge),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<AwardJudgeRef>(fetchContext.errorStore, response, 'assign country award judge'));
